.error {
  background-color: #d04d52;
  color: #fff !important;
  border: 1px solid #d04d52;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 4px;
  margin-right: 4px;
  display: inline-block;
}
